import type { LandingDemoReplay } from "@/components/marketing/HeroDemoPlayer";
import HeroSection from "@/components/marketing/HeroSection";
import MarketingSections from "@/components/marketing/MarketingSections";

type HomeProps = {
  app_base_url: string;
  landing_demo: LandingDemoReplay;
};

export default function Home({ app_base_url, landing_demo }: HomeProps) {
  return (
    <div className="min-h-screen bg-white">
      <title>ScoutUX — Find what makes your product harder to use</title>
      <meta
        name="description"
        content="Start free on public pages. Upgrade to audit your product. Evidence on every finding. Recheck weekly."
      />
      <HeroSection appBaseUrl={app_base_url} landingDemo={landing_demo} />
      <MarketingSections appBaseUrl={app_base_url} landingDemo={landing_demo} />
    </div>
  );
}
